import React, { useState, useEffect } from 'react'
import { TranslationContext } from './context'
import { useConfig } from '../config/use'
import axios from 'axios'
import { isFalsyOrEmpty } from '../../components/helpers/object'

export const TranslationProvider = ({children}) => {
  const [resources, setResources] = useState();
  const [language, setLanguage] = useState('Svenska');
  const { state: { config }, actions: {GetCheckinData}} = useConfig();
  useEffect(() => {
    async function GetResources() {
      await axios({
        method: 'get',
        url: './translations.json',
        responseType: 'json'
      })
      .then(res => {setResources(res.data);})
    }
    GetResources();
    var storedlang = localStorage.getItem('language');
    if (storedlang)
    {
      setLanguage(storedlang);
      document.documentElement.lang = storedlang;
    }
  }, [])

  useEffect(() => {
    if (config)
    {
      var storedlang = localStorage.getItem('language');
      if (storedlang)
      {
        setLanguage(storedlang);
        document.documentElement.lang = storedlang;
      }
      else
      {
        setLanguage(config.defaultLanguage);
        document.documentElement.lang = config.defaultLanguage;
        localStorage.setItem('language', config.defaultLanguage);
      }
    }
  }, [config])

  const t = text => {
    if (resources && language)
    {
      const splitted = text.split(".");
      if (splitted.length > 0)
      {
        var result = resources.Languages.find(x => x.name === language).value;
        try{
          for(var i = 0; i < splitted.length; i++)
          {
            result = result[splitted[i]]
          }
        }
        catch{
          return "Please fix your translation file"
        }
        return result
      }
    }
    return ""
  }

  const dt = (officeid, textname) => {
    const formname = localStorage.getItem("formname");
    if (resources && language)
    {
      const result = resources.Languages.find(x => x.name === language).value;
        var res = result["formspage"];
        var officetranslations = res["templates"]["officespecific"].find(x => x.officeid === officeid);
        if (officetranslations)
        {
          var officetext = officetranslations["texts"].find(x => x.name === formname);
          if (!isFalsyOrEmpty(officetext))
          {
            var textobj = officetext.value.find(x => x.id === textname);
            if (textobj)
              return textobj.text;
          }
        }
        
        var template = result["formspage"]["templates"]["generic"].find(x => x.name === formname);
        if (!isFalsyOrEmpty(template))
        {
          var templatetext = template.value.find(x => x.id === textname);
          if (templatetext)
            return templatetext.text;
        }
      console.error("Could not load your dynamic translations");
      return null;
    }
  }

  const ct = (officeid, textid) => {
    if (resources && language)
    {
      try
      {
        const result = resources.Languages.find(x => x.name === language).value;
        const checkin = result["checkinpage"];
        const officespecific = checkin["offices"]
        const office = officespecific.find(x => x.id === officeid);
        if (!isFalsyOrEmpty(office))
          return office.values[textid];
        else
          return checkin["generic"][textid];
      }
      catch(error)
      {
        console.error("Could not load your dynamic translations");
        return null;
      }
    }
    else
    {
      console.error("Could not load your dynamic translations");
      return null;
    }
  }

  const qt = (queueid) => {
    if (resources && language && queueid)
    {        
      const result = resources.Languages.find(x => x.name === language).value;
      try {
        const queuepage = result["queuepage"];
        const dynamictranslations = queuepage["queuenames"];
        const value = dynamictranslations.find(x => x.id === queueid);
        if (!isFalsyOrEmpty(value))
          return value.text;
        else
          return null;
      }
      catch
      {
        console.error("Could not load your dynamic translations")
        return null;
      }
    }
  }

  const ot = (officeid) => {
    if (resources && language && officeid)
    {
      const result = resources.Languages.find(x => x.name === language).value;
      try {
        const landingpage = result["landingpage"];
        const dynamictranslations = landingpage["officenames"];
        const value = dynamictranslations.find(x => x.id === officeid);
        if (!isFalsyOrEmpty(value))
          return value.text;
        else
          return null;
      }
      catch
      {
        console.error("Could not load your dynamic translations")
        return null;
      }
    }
  }

  const tt = (category, queueid, source) => {
    const officeID = localStorage.getItem("selectedoffice");
    if (resources && language && queueid && officeID)
    {        
      const result = resources.Languages.find(x => x.name === language).value;
      try {
        const ticketpage = result["ticketpage"];
        const dynamictranslations = ticketpage[category];
        const officespecificmessages = dynamictranslations.offices.find(x => x.id === officeID);
        if (!isFalsyOrEmpty(officespecificmessages))
        {
          let value;
          if (localStorage.getItem("isBooking"))
          {
            value = officespecificmessages.value[source].find(x => x.id === "booking");
          }
          else
            value = officespecificmessages.value[source].find(x => x.id === queueid);

          if (!isFalsyOrEmpty(value))
            return value.text;
        }
        return null;
      }
      catch
      {
        console.error("Could not load your dynamic translations")
        return null;
      }
    }
  }

  const sp = (text, officeID) => {
    // TODO: Make a generic function to replace internationalization features. But for now just handle datetime.
    if (config)
    {
      var checkindata = GetCheckinData(officeID);
      if (checkindata)
      {
        if (text.includes("{2earlytime"))
        {
          var toearlytext = text.replace("{2earlytime}", checkindata.toEarlyCheckinMinutes);
          return toearlytext;
        }
        if (text.includes("{2latetime"))
        {
          var tolatetext = text.replace("{2latetime}", checkindata.toLateCheckinMinutes);
          return tolatetext;
        }
      } 
      return text;
    }
    else 
      return text;
  }

  const updateLanguage = newlang => {
    if (resources && language)
    {
      var result = resources["Languages"].find(x => x.name === newlang);
      if (result)
      {
        setLanguage(newlang);
        localStorage.setItem('language', newlang);
        document.documentElement.lang = newlang;
      }
    }
  }

  const value = {
    state: { resources },
    actions: {t, dt, qt, tt, ct, sp, ot, updateLanguage}
  }

  return (
    <TranslationContext.Provider value = {value}>
      { children }
    </TranslationContext.Provider>
  )
}
